"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toObject = toObject;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function toObject(source) {
  const obj = {};

  for (const [key, value] of (0, _iterable.ensureIterable)(source)) {
    obj[key] = value;
  }

  return obj;
}

var _default = toObject;
exports.default = _default;